<template>
  <button 
    @click="toggleTheme"
    class="relative w-10 h-10 rounded-lg bg-primary-10 hover:bg-primary-20 transition-colors duration-300 flex items-center justify-center"
    :title="isDark ? '切换到亮色模式' : '切换到暗色模式'"
  >
    <!-- 月亮图标 (暗色模式) -->
    <svg 
      v-if="isDark"
      class="w-5 h-5 text-primary-600"
      fill="currentColor" 
      viewBox="0 0 20 20"
    >
      <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
    </svg>

    <!-- 太阳图标 (亮色模式) -->
    <svg 
      v-else
      class="w-5 h-5 text-yellow-400"
      fill="currentColor" 
      viewBox="0 0 20 20"
    >
      <path 
        fill-rule="evenodd" 
        d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" 
        clip-rule="evenodd" 
      />
    </svg>
  </button>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const isDark = ref(true)

const toggleTheme = () => {
  isDark.value = !isDark.value
  updateTheme()
}

const syncThemeClass = (theme) => {
  const root = document.documentElement
  root.classList.remove('dark', 'light')
  root.classList.add(theme)

  if (document.body) {
    document.body.classList.remove('dark', 'light')
    document.body.classList.add(theme)
  }
}

const updateTheme = () => {
  const theme = isDark.value ? 'dark' : 'light'
  syncThemeClass(theme)
  // 保存到本地存储
  localStorage.setItem('theme', theme)
}

onMounted(() => {
  // 从本地存储读取主题设置
  const savedTheme = localStorage.getItem('theme')
  if (savedTheme) {
    isDark.value = savedTheme === 'dark'
  } else {
    // 检测系统主题偏好
    isDark.value = window.matchMedia('(prefers-color-scheme: dark)').matches
  }
  updateTheme()
})
</script>
